import { CustomReportVariable, ExplainerVariable } from '../../../../../../redux/context/customReports/typesVariable'
import { ReportDataType } from '../../../../../../redux/context/reports/types'
import { vouchersConfig } from '../../../../../../config/integrations/vouchers'
import { TaskApplication } from '../../../../../superuser/types'
import { CustomColumnContext } from '../types'

export const canShowContextMenu = (
  record: CustomReportVariable | ExplainerVariable,
  columnContext: CustomColumnContext,
  canReadVouchers: boolean
): boolean => {
  // Safe destructuring with null checks
  const { company } = columnContext || {}
  const { accountingSoftware } = company || {}

  // Early returns for quick exits
  if (!accountingSoftware || !vouchersConfig[accountingSoftware as TaskApplication]) return false
  if (!('account' in record) || !record.account) return false
  if (columnContext.category.type !== 'periodGroup') return false

  // Check permissions
  if (!canReadVouchers) return false

  // Check data type conditions
  const allowedDataTypes = [ReportDataType.actuals, ReportDataType.forecast]
  const isValidDataType = !columnContext.category.dataType || allowedDataTypes.includes(columnContext.category.dataType)

  return isValidDataType
}
